import TableContainer from 'components/Common/TableContainer'
import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Container, UncontrolledTooltip } from 'reactstrap'
import TriggerForm from './TriggerForm'
import { useDispatch } from 'react-redux'
import { getAllRenewalTrigger } from 'store/actions'
import { useSelector } from 'react-redux'
import moment from 'moment'

const RenewalTrigger = () => {
    const dispatch = useDispatch();
const { error, responseMsg, loading, autoRenewalTriggersList } = useSelector(state => state.RenewalReducer);
    const [renewalTrackTrigger, setRenewalTrackTrigger] = useState({
        isShow: false,
        isEdit: false,
        isView: false,
        data: ""
    })

    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
            },
            {
                Header: "Name",
                accessor: "name",
                filterable: true,
                Cell: cellProps => {
                    return cellProps.value
                },
            },
            {
                Header: "Filter Mode",
                accessor: "filter_mode",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value}</>
                },
            },
            {
                Header: "Filter Frequency",
                accessor: "filter_frequency",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value}</>
                },
            },
            {
                Header: "Trigger Frequency",
                accessor: "trigger_frequency",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value}</>
                },
            },
            {
                Header: "Weekly Trigger Day",
                accessor: "weekly_trigger_day",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value}</>
                },
            },
            {
                Header: "Monthly Trigger Date",
                accessor: "monthly_trigger_date",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value}</>
                },
            },
            {
                Header: "Start Date",
                accessor: "start_date",
                filterable: true,
                Cell: cellProps => {
                    return <>{moment(cellProps.value).format("DD/MM/YYYY")}</>
                },
            },
            // {
            //     Header: "Next Trigger Date",
            //     accessor: "next_trigger_date",
            //     filterable: true,
            //     Cell: cellProps => {
            //         return <>{moment(cellProps.value).format("DD/MM/YYYY")}</>
            //     },
            // },
            {
                Header: "Status",
                accessor: "status",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value == 1 ? <div className='p-1 bg-success w-100 text-center text-white rounded'>Active</div>:  <div className='p-1 bg-danger w-100 text-center text-white rounded'>Inactive</div>}</>
                },
            },

            {
                Header: "Action",
                accessor: "action",
                disableFilters: true,
                Cell: cellProps => {

                    return (
                        <>
                            <ul className="list-unstyled hstack gap-1 mb-0">
                                <li
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="View"
                                    onClick={()=>showCreateTriggerModal({ isShow:true, isEdit:false, isView:true, data:cellProps.row.original })}
                                >
                                    <Link
                                        className="btn btn-sm btn-soft-primary"
                                        id={`viewtooltip-${cellProps.row.original.id}`}
                                    >
                                        <i className="mdi mdi-eye-outline" />
                                    </Link>
                                </li>
                                <UncontrolledTooltip
                                    placement="top"
                                    target={`viewtooltip-${cellProps.row.original.id}`}
                                >
                                    view
                                </UncontrolledTooltip>

                                <li>
                                    <Link
                                        // to={`/update-policy/${id}/${cellProps.row.original.id}`}
                                        className="btn btn-sm btn-soft-info"
                                        id={`edittooltip-${cellProps.row.original.id}`}
                                        onClick={()=>showCreateTriggerModal({ isShow:true, isEdit:true, isView:false, data:cellProps.row.original })}
                                    >
                                        <i className="mdi mdi-pencil-outline" />
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`edittooltip-${cellProps.row.original.id}`}
                                        >
                                            Edit
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                                {/* Delete */}

                                {/* <li>
                                    <Link
                                        // to={`/update-policy/${id}/${cellProps.row.original.id}`}

                                        className="btn btn-sm btn-soft-info"
                                        id={`deletetooltip-${cellProps.row.original.id}`}
                                    >
                                        <i className="mdi mdi-delete" />
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`deletetooltip-${cellProps.row.original.id}`}
                                        >
                                            Delete
                                        </UncontrolledTooltip>
                                    </Link>
                                </li> */}


                            </ul>
                        </>
                    )
                },
            },
        ],
        []
    )

    const showCreateTriggerModal = ({ isShow, isEdit, isView, data }) => {
        setRenewalTrackTrigger({
            ...renewalTrackTrigger,
            isShow, // Set isShow based on the parameter
            isEdit, // Set isEdit based on the parameter
            isView, // Set isView based on the parameter
            data: isShow && !isEdit && !isView ? "" : data, // Set data conditionally
        });
    };

    useEffect(()=>{
        dispatch(getAllRenewalTrigger())
    },[])
    return (
        <div className="page-content">
            <Container fluid className='bg-white shadow p-3'>
                <div className='d-flex justify-content-between'>
                    <div>
                        <h2>Renewal Tracking Triggers</h2>
                    </div>

                    <div>
                        <Button color='primary' onClick={()=>showCreateTriggerModal({ isShow:true, isEdit:false, isView:false, data:"" })}>Create Trigger</Button>
                    </div>
                </div>

                <div>
                    <TableContainer
                        columns={columns}
                        data={autoRenewalTriggersList}
                        Loading={loading}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        isJobListGlobalFilter={false}
                        isPagination={true}
                        iscustomPageSizeOptions={true}
                        isShowingPageLength={true}
                        customPageSize={15}
                        tableClass="table-bordered align-middle nowrap mt-2"
                        paginationDiv="col-sm-12 col-md-7"
                        pagination="pagination justify-content-end pagination-rounded"
                    />
                </div>
            </Container>

            <TriggerForm
            renewalTrackTrigger={renewalTrackTrigger}
            setRenewalTrackTrigger={setRenewalTrackTrigger}
            />
        </div>
    )
}

export default RenewalTrigger